module.exports = __webpack_public_path__ + "static/pic05-fd2bb51da50cba2d11c54feef0b50f80.jpg";